import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { getQueryParamValue } from "@chatfood/core-utils";
import { isClient } from "@/utils/is-client";
import { useBasketStore } from "#imports";

export default defineNuxtRouteMiddleware(async (to) => {
  if (!isClient()) return;

  const QUERY_ID = "add-plu";
  const plu = getQueryParamValue(to.query, QUERY_ID);

  if (!plu) return;

  const basketStore = useBasketStore();

  if (!basketStore.isLoaded) {
    basketStore.addPendingAction({ type: "addItem", plu });
  } else {
    try {
      await basketStore.addItemByPlu(plu);
    } catch {
      // Fail silently - addItemByPlu already has internal error handling
    }
  }

  const { [QUERY_ID]: _, ...cleanQuery } = to.query;

  return navigateTo(
    {
      path: to.path,
      query: cleanQuery,
      hash: to.hash,
    },
    { replace: true },
  );
});
